import BaseClient from '@/app/model/api/response/baseApiClient'

class AccountListApi extends BaseClient {
  public getAccountList (data: any) {
    const path = '/v1/master/users'
    var url = new URL(process.env.VUE_APP_API_URL + path)
    var params = new URLSearchParams({})

    if (data !== '') {
      if (data.type !== 0) {
        params.append('user_type', data.type)
      }

      if (data.text !== '') {
        params.append('word', data.text)
      }

      if (data.num !== '0') {
        params.append('order_name', data.order_name)
        params.append('sort', data.sort)
      }
    }

    url.search = params.toString()

    /* 共通処理 */
    return super.doFetch(decodeURI(url.href), 'GET')
  }
}

export default new AccountListApi()
